import { IMenu } from './interfaces';

export const getSlug = ({ url, params: { id1, id2 } }: any) => {
  if (/^(\/?\S{2})?\/people$/.test(url)) {
    return 'people';
  }

  return id1 || id2;
};

export const findSelectedTopMenu = (
  menuItems: IMenu[],
  currentMenu: IMenu,
): IMenu | null => {
  if (!currentMenu) {
    return menuItems[0];
  }

  if (!currentMenu.parentId) {
    return currentMenu;
  }

  const parent = menuItems.find(item => item.id === currentMenu.parentId);

  if (!parent) {
    return null;
  }

  return findSelectedTopMenu(menuItems, parent);
};
